export const KnownSpecialHeaders = ["repeatability-request-id", "repeatability-first-sent"];
